import {
  motion, useAnimate,
} from 'framer-motion';
import { useEffect } from 'react';
import ChestRewardGlow from '../../assets/svg/chests/glows/chest-reward-glow.svg';
import Button from '../../Components/Button';
import RocketIcon from '../../assets/svg/utils/rocket/rocket.svg';
import USDTIcon from '../../assets/svg/utils/usdt.svg';
import { useAppSelector } from '../../store';
import { TChestRewardHistory } from '../../types';
import { getChestRewardIcons } from './utils/getChestRewardIcons';

type TReceivedChestRewardProps = {
  reward: TChestRewardHistory;
  onCollect: () => void;
  classNames?: {
    rewards?: {
        wrapper?: string;
    };
    button?: string
    icons?: {
      wrapper?: string
    }
  }
}

function ReceivedChestReward({ classNames, onCollect, reward }: TReceivedChestRewardProps) {
  const { chestsList } = useAppSelector(({ chests }) => chests);

  const chest = chestsList.find((c) => c.id === reward.chest_id);

  const {
    chest: chestIcon, reward: rewardIcon, shine: shineIcon, chestShine: chestShineIcon,
  } = getChestRewardIcons(`${chest?.variant ?? 'supernova'}-${reward.variant}`);

  const [scope, animate] = useAnimate();

  useEffect(() => {
    animate('#shine', {
      opacity: [0, 1, 1, 0],
      scale: [0, 3, 1],
      rotate: 45,
    }, {
      ease: 'easeInOut',
      duration: 1.25,
    });

    animate('#chest-reward-icon', {
      opacity: [0, 1],
    }, {
      delay: 0.1,
      duration: 0.5,
      ease: 'easeInOut',
    });
  }, []);

  if (!chest) {
    return null;
  }

  return (
    <div className="font-Bangers text-[#fff] flex flex-col items-center text-[32px]">
      <span className="text-center">
        You opened an
        <br />
        {chest.variant}
        {' '}
        Chest
      </span>
      <div className={`relative mt-2 aspect-[1/1.1] w-full h-full ${classNames?.icons?.wrapper ?? 'max-w-[237px]'}`} ref={scope}>
        <motion.div
          id="chest-reward-icon"
          initial={{
            opacity: 0,
          }}
        >
          {chestShineIcon}
          {chestIcon}
          {rewardIcon}
          {shineIcon}
        </motion.div>
        <motion.div
          id="shine"
          className="absolute inset w-full h-full flex items-center justify-center"
        >
          <img src={ChestRewardGlow} alt="chest-reward-glow" />
        </motion.div>
      </div>
      <div className={classNames?.rewards?.wrapper ?? 'mt-[46px]'}>
        <span className="text-[26px]">Your reward is</span>
        <div className="flex gap-2">
          {/* eslint-disable-next-line eqeqeq */}
          {(!!reward.multiplier && reward.multiplier != 1)
          && (
          <div className="chest-multiplier">
            X
            {reward.multiplier}
          </div>
          )}
          <div className="flex justify-center text-[20px] gap-8 gradient-border reward px-2">
            <div className="flex items-center gap-2">
              <img src={USDTIcon} width={24} alt="usdt-coin" />
              <span>
                +
                {reward.rewards.usdt}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <img src={RocketIcon} width={24} alt="rocket-coin" />
              <span>
                +
                {reward.rewards.rocketCoins}
              </span>
            </div>
          </div>
        </div>

      </div>
      <Button
        onClick={onCollect}
        className={`btn navy w-[calc(100%-32px)] py-[16px] text-[24px] ${classNames?.button ?? 'absolute bottom-[86px]'}`}
      >
        Collect
      </Button>
    </div>
  );
}

export default ReceivedChestReward;
